import { Avatar, CircularProgress, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useGetCandidateTimelineQuery } from "../../../redux/Hire/jobRequestApi";
import { stringAvatar } from "../../../utils/CommonFunction";

type Props = {
  candidateId: string;
};

const defaultStyle = {
  fontSize: "14px",
  lineHeight: "20px",
  color: "#0F1829",
  fontWeight: 400,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const Timeline = ({ candidateId }: Props) => {
  const { data, isLoading } = useGetCandidateTimelineQuery(
    {
      id: candidateId || "",
    },
    {
      skip: !candidateId,
    },
  );
  if (isLoading) {
    return (
      <Grid container justifyContent="center" alignItems="center">
        <CircularProgress />
      </Grid>
    );
  }
  if (data?.data && data?.data?.length === 0) {
    return (
      <Grid container justifyContent="center" alignItems="center">
        <Typography
          fontSize={"14px"}
          lineHeight={"14px"}
          color={"#98A2B3"}
          textAlign={"center"}
        >
          No timeline events available
        </Typography>
      </Grid>
    );
  }
  return (
    <Grid container direction={"column"} gap={2}>
      <Grid container item gap={2} wrap="nowrap">
        <Grid item xs={3}>
          <Typography
            fontSize={"12px"}
            lineHeight={"12px"}
            fontWeight={700}
            color={"#667086"}
            textTransform={"uppercase"}
          >
            User
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography
            fontSize={"12px"}
            lineHeight={"12px"}
            fontWeight={700}
            color={"#667086"}
            textTransform={"uppercase"}
          >
            Date
          </Typography>
        </Grid>

        <Grid item xs={7}>
          <Typography
            fontSize={"12px"}
            lineHeight={"12px"}
            fontWeight={700}
            color={"#667086"}
            textTransform={"uppercase"}
          >
            Action
          </Typography>
        </Grid>
      </Grid>
      {data?.data.map((timelineItem) => (
        <Grid
          container
          item
          gap={2}
          wrap="nowrap"
          key={timelineItem.id}
          alignItems={"center"}
        >
          <Grid
            container
            item
            xs={3}
            gap={1}
            wrap="nowrap"
            alignItems={"center"}
          >
            <Avatar
              {...stringAvatar(timelineItem.addedByUName || "Teamified Admin")}
            />
            {timelineItem.addedByUName ? (
              <Typography sx={defaultStyle}>
                {timelineItem.addedByUName}
              </Typography>
            ) : (
              <Typography sx={defaultStyle}>Unknown User</Typography>
            )}
          </Grid>
          <Grid item xs={2}>
            <Typography sx={defaultStyle}>
              {moment
                .utc(timelineItem.addedOn)
                .local()
                .format("Do MMM yy, hh:mm A")}
            </Typography>
          </Grid>
          <Grid item xs={7}>
            <Typography sx={{ ...defaultStyle, fontWeight: 600 }}>
              {timelineItem.text}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default Timeline;
